import {IssuePersonalData} from "../domain/entities/issue-personal-data.entity";
import {CommandName} from "./command-name.enum";
import {AbstractCommand} from "./abstract.command";

/**
 * Moves an existing row from its current Label to another — never creates a
 * row. See `MoveIssueToAnotherPersonalLabelCommandHandler`.
 *
 * `mainEntityClass`/`mainEntityUid`: see `CreateIssuePersonalDataCommand`'s own
 * doc comment (must point at this row, never at the referenced Issue).
 */
export class MoveIssueToAnotherPersonalLabelCommand extends AbstractCommand<IssuePersonalData> {

    name = CommandName.MOVE_ISSUE_TO_ANOTHER_PERSONAL_LABEL;

    tags = ['entity', 'move', 'issue-personal-data'];

}
